import React, { useState, useEffect } from "react";
import SectionCards from "./SectionCards";
import RDevQuiz from "./r_sat_body";
import { BASELINE } from "../../util";
import Check_topics from "./check_problems";
import axios from "axios";

const Main_review = () => {
    // dashboard states: -1 = login, 0 = section cards, 1 = Check_topics, 2 = question detail
    const [dashboard, setDashboard] = useState(-1);
    const [emailInput, setEmailInput] = useState("");
    const allowedEmails = [
        "anwenj@mmtprep.com",
        "thomasa@mmtprep.com",
        "kaylar@mmtprep.com",
        "alina@mmtprep.com",
        "danem@mmtprep.com",
        "seank@mmtprep.com",
        "angiek@mmtprep.com",
        "aiden1393@gmail.com"
    ];
    // id will be set to the username extracted from the email
    const [id, setId] = useState("");
    const [skilldesc, setSkilldesc] = useState("");
    const [questionIds, setQuestionIds] = useState("");
    const [questionIdList, setQuestionIdList] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [refreshTopics, setRefreshTopics] = useState(0);

    // Example section data
    const [readingWritingSections, setReadingWritingSections] = useState([
        { name: "Inferences", total: 50, check: 0 },
        { name: "Central Ideas and Details", total: 40, check: 0 },
        { name: "Command of Evidence", total: 60, check: 0 },
        { name: "Words in Context", total: 45, check: 0 },
        { name: "Text Structure and Purpose", total: 55, check: 0 },
        { name: "Cross-Text Connections", total: 30, check: 0 },
        { name: "Rhetorical Synthesis", total: 20, check: 0 },
        { name: "Transitions", total: 25, check: 0 },
        { name: "Boundaries", total: 15, check: 0 },
        { name: "Form, Structure, and Sense", total: 10, check: 0 },
    ]);

    const [mathSections, setmathSections] = useState([
        { name: "Linear functions", total: 60, check: 30 },
        { name: "Systems of two linear equations in two variables", total: 45, check: 25 },
        { name: "Linear inequalities in one or two variables", total: 55, check: 35 },
        { name: "Linear equations in one variable", total: 50, check: 20 },
        { name: "Nonlinear functions", total: 40, check: 10 },
        { name: "Equivalent expressions", total: 35, check: 15 },
        { name: "Ratios, rates, proportional relationships, and units", total: 30, check: 10 },
        { name: "Probability and conditional probability", total: 25, check: 5 },
        { name: "One-variable data: Distributions and measures of center and spread", total: 20, check: 5 },
        { name: "Two-variable data: Models and scatterplots", total: 15, check: 5 },
        { name: "Percentages", total: 10, check: 2 },
        { name: "Lines, angles, and triangles", total: 8, check: 3 },
        { name: "Right triangles and trigonometry", total: 6, check: 2 },
        { name: "Area and volume", total: 5, check: 1 },
        { name: "Circles", total: 4, check: 1 },
    ]);

    // Login handling (dashboard === -1)
    const handleEmailSubmit = () => {
        const normalizedEmail = emailInput.toLowerCase().trim();
        if (allowedEmails.includes(normalizedEmail)) {
            const username = normalizedEmail.split("@")[0];
            setId(username);
            setDashboard(0);
            logLogin(username);
        } else {
            alert("You are not authorized to access this page.");
        }
    };

    // When a card is clicked, update skilldesc, then log the click, then switch to Check_topics.
    const handleCardClick = (cardName) => {
        setSkilldesc(cardName);
        // Log the click event
        logClick(cardName);
        setDashboard(1);
    };

    // Function to get current LA time in 'YYYY-MM-DD HH:MM:SS' format.
    const getLATimeString = () => {
        const date = new Date().toLocaleDateString("en-CA", { timeZone: "America/Los_Angeles" });
        const time = new Date().toLocaleTimeString("en-US", {
            timeZone: "America/Los_Angeles",
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        return `${date} ${time}`;
    };

    // Log click event function: sends log with format: "{id} clicked {cardName} at {time}"
    const logClick = (cardName) => {
        if (!id) return; // If not logged in, don't log.
        const currentLATime = getLATimeString();
        const logMessage = `${id} clicked ${cardName} at ${currentLATime}`;
        axios
            .post(BASELINE + "add/log", {
                uid: id,
                question_id: "", // For a click event, no question_id.
                log: logMessage,
                currentLATime: currentLATime,
            })
            .then((response) => {
                if (response.data.success) {
                } else {
                    console.error("Failed to add click log.");
                }
            })
            .catch((error) => {
                console.error("Error adding click log:", error);
            });
    };

    // Check_topics onSelectQuestion handler from within Check_topics
    const handleSelectQuestion = (selectedId, index, list) => {
        setQuestionIds(selectedId);
        setQuestionIdList(list);
        setCurrentQuestionIndex(index);
        setDashboard(2);
    };

    // Next/Previous handlers for question list navigation
    const handleNextQuestion = () => {
        if (questionIdList && currentQuestionIndex < questionIdList.length - 1) {
            const newIndex = currentQuestionIndex + 1;
            setCurrentQuestionIndex(newIndex);
            setQuestionIds(questionIdList[newIndex]);
        } else {
            alert("No more questions.");
        }
    };

    const handlePreviousQuestion = () => {
        if (questionIdList && currentQuestionIndex > 0) {
            const newIndex = currentQuestionIndex - 1;
            setCurrentQuestionIndex(newIndex);
            setQuestionIds(questionIdList[newIndex]);
        } else {
            alert("This is the first question.");
        }
    };

    const logLogin = (username) => {
        // Define options for Los Angeles time zone in 24-hour format.
        const options = { timeZone: "America/Los_Angeles", hour12: false };
        // Get current time in LA as a string.
        const currentLATime = String(new Date().toLocaleString("en-US", options));
        const logNote = `${username} log-in at ${currentLATime}`;

        axios
            .post(BASELINE + "add/log", {
                uid: username,
                question_id: "",  // For login events, no question_id is provided.
                log: logNote,
                currentLATime: currentLATime
            })
            .then((response) => {
                if (response.data.success) {
                } else {
                    console.error("Failed to add log entry.");
                }
            })
            .catch((error) => {
                console.error("Error adding log entry:", error);
            });
    };

    const fetchCardData = async (skill) => {
        try {
            const response = await axios.post(BASELINE + "select/gen/topicai", { skill_descs: skill });
            if (response.data.success) {
                const rows = response.data.data;
                const total = rows.length;
                const check = rows.reduce((sum, row) => sum + (Number(row.completed) || 0), 0);
                return { total, check };
            }
        } catch (error) {
            console.error("Error fetching data for", skill, error);
            return null;
        }
    };

    const updateReadingWritingSections = async () => {
        const updatedData = await Promise.all(
            readingWritingSections.map(async (card) => {
                const data = await fetchCardData(card.name);
                if (data) {
                    return { ...card, total: data.total, check: data.check };
                }
                return card;
            })
        );
        setReadingWritingSections(updatedData);
    };

    useEffect(() => {
        updateReadingWritingSections();
        updateMathSections();
    }, []);

    const updateMathSections = async () => {
        const updatedData = await Promise.all(
            mathSections.map(async (card) => {
                const data = await fetchCardData(card.name);
                if (data) {
                    return { ...card, total: data.total, check: data.check };
                }
                return card;
            })
        );
        setmathSections(updatedData);
    };

    if (dashboard === -1) {
        return (
            <div className="max-w-xl mx-auto p-8 text-center">
                <h1 className="text-3xl font-bold mb-4">Enter your permissioned email</h1>
                <input
                    type="email"
                    placeholder="Enter email"
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                    className="border p-2 rounded w-full"
                />
                <button
                    onClick={handleEmailSubmit}
                    className="bg-blue-500 text-white p-2 rounded mt-4"
                >
                    Submit
                </button>
            </div>
        );
    }

    return (
        <>
            {dashboard === 0 && (
                <div className="max-w-5xl mx-auto p-8">
                    <div className="text-center mb-12">
                        <h1 className="text-5xl font-extrabold text-slate-800">
                            SAT Problem Review Center
                        </h1>
                        <p className="mt-4 text-xl text-gray-600">
                            Welcome {id}, please be aware that the problem cannot be reverted once you save the data.
                            Please double-check before hitting the save button!
                        </p>
                        <button className="bg-slate-500 p-4 m-2" onClick={() => {
                            updateReadingWritingSections();
                            updateMathSections();
                        }}>Refresh</button>
                    </div>
                    <div className="space-y-12">
                        <div>
                            <h2 className="text-3xl font-bold mb-6">Reading &amp; Writing</h2>
                            <SectionCards
                                sections={readingWritingSections}
                                onCardClick={(cardName) => {
                                    handleCardClick(cardName);
                                }}
                                setdashboard={setDashboard}
                            />
                        </div>
                        <div>
                            <h2 className="text-3xl font-bold mb-6">Math</h2>
                            <SectionCards
                                sections={mathSections}
                                onCardClick={(cardName) => {
                                    handleCardClick(cardName);
                                }}
                                setdashboard={setDashboard}
                            />
                        </div>
                    </div>
                </div>
            )}
            {dashboard === 1 && (
                <Check_topics
                    skilldesc={skilldesc}
                    setdashboard={setDashboard}
                    setquestionIds={setQuestionIds}
                    onSelectQuestion={handleSelectQuestion}
                    roww={0}
                />
            )}
            {dashboard === 2 && (
                <RDevQuiz
                    id={id}
                    skilldesc={skilldesc}
                    questionIds={questionIds}
                    setdashboard={setDashboard}
                    onNext={handleNextQuestion}
                    onBack={handlePreviousQuestion}
                    onSelectQuestion={handleSelectQuestion}
                />
            )}
        </>
    );
};

export default Main_review;
